import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppDispatch, RootState } from '../../store';
import { actionLogin } from '../../store/slice/auth';

import { getRequest } from '../../services/request';
import { ASSETS_URL_LOGIN, SERVER_TYPE } from '../../settings/constants';
import { MAIN_ROUTER } from '../../routers/constants';

import LoadingScreen from 'components/core/common/Loading';

interface Props {
  children: React.ReactNode;
}

// TODO: handle logic redirect, layout
function WithAuthLayoutHOC({ children }: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isAuth } = useSelector((state: RootState) => state.auth);
  const [isLoading, setIsLoading] = useState(false);

  // get token
  const url = window.location.href.split('?')?.[1];
  if (url) {
    const searchParams = new URLSearchParams(url);
    const code = searchParams.get('code');
    const session_state = searchParams.get('session_state');
    if (code && session_state && !isLoading) {
      setIsLoading(true);
      getRequest(
        `${ASSETS_URL_LOGIN}/oauth/token?type=${SERVER_TYPE}&code=${code}`
      )
        .then(
          async (res: any) => {
            if (res?.access_token?.length > 0) {
              await dispatch(
                actionLogin({
                  isAuth: true,
                  userInfo: { ...res },
                  accessToken: res?.access_token
                })
              );
            } else {
              dispatch(actionLogin({ isAuth: false, userInfo: {} }));
            }
          },
          async (err: any) => {}
        )
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  // Open the laser dashboard after authentication.
  useEffect(() => {
    if (isAuth) {
      navigate(MAIN_ROUTER.DASHBOARD_LASER, { replace: true });
    }
  }, [isAuth, navigate]);

  return <Suspense fallback={<LoadingScreen />}>{children}</Suspense>;
}

export default WithAuthLayoutHOC;
